<div class="row">
  <div class="col-12">
    <div class="card">
      <div
        _ngcontent-rps-c192=""
        class="card-header spear-table-header-background d-flex justify-content-between"
      >
        <h6>Invoices</h6>
        <div>
          <button
            class="btn viewBtn spear-button-background text-white btn-sm"
            [routerLink]="['/limos/invoice']"
            [queryParams]="{ type: 'new' }"
          >
            New Invoice
          </button>
        </div>
      </div>

      <div class="filter-section" [formGroup]="invoiceFilter">
        <div class="row mb-2 mx-1 mt-3">
          <div class="col-2">
            <label for="invoice_number" class="form-label fw-500 text-dark-bold text-sm">Invoice No.</label>
            <input type="text" class="form-control" id="invoice_number" formControlName="invoice_number"/>
          </div>
          <div class="col-2">
            <label for="invoice_case_number" class="form-label fw-500 text-dark-bold text-sm">Invoice Case No.</label>
            <input type="text" class="form-control" id="invoice_case_number" formControlName="invoice_case_number"/>
          </div>
          <div class="col-2">
            <label for="case_number" class="form-label fw-500 text-dark-bold text-sm">Case No.</label>
            <input type="text" class="form-control" id="case_number" formControlName="case_number"/>
          </div>
          <div class="col-2">
            <label for="claim_number" class="form-label fw-500 text-dark-bold text-sm">Claim No.</label>
            <input type="text" class="form-control" id="claim_number" formControlName="claim_number"/>
          </div>
          <div class="col-2">
            <label for="provider_name" class="form-label fw-500 text-dark-bold text-sm">Provider Name</label>
            <input type="text" class="form-control" id="provider_name" formControlName="provider_name"/>
          </div>
          <div class="col-2">
            <label for="client_name" class="form-label fw-500 text-dark-bold text-sm">Client Name</label>
            <input type="text" class="form-control" id="client_name" formControlName="client_name"/>
          </div>
        </div>

        <div class="row mb-2 mx-1">
          <div class="col-2">
            <label for="subject_name" class="form-label fw-500 text-dark-bold text-sm">Subject Name</label>
            <input type="text" class="form-control" id="subject_name" formControlName="subject_name"/>
          </div>
          <div class="col-2">
            <label for="program_location_id" class="form-label fw-500 text-dark-bold text-sm">Program Location Id</label>
            <input type="text" class="form-control" id="program_location_id" formControlName="program_location_id"/>
          </div>
          <div class="col-2">
            <label for="client_contact_id" class="form-label fw-500 text-dark-bold text-sm">Client Contact Id</label>
            <input type="text" class="form-control" id="client_contact_id" formControlName="client_contact_id"/>
          </div>
          <div class="col-2">
            <label for="created_on" class="form-label fw-500 text-dark-bold text-sm">Created On</label>
            <input type="text" class="form-control" id="created_on" jDate [formCtrl]="invoiceFilter.controls['created_on']"/>
          </div>
          <div class="col-2">
            <label for="from_date" class="form-label fw-500 text-dark-bold text-sm">From Date</label>
            <input type="text" class="form-control" id="from_date" jDate [formCtrl]="invoiceFilter.controls['from_date']"/>
          </div>
          <div class="col-2">
            <label for="to_date" class="form-label fw-500 text-dark-bold text-sm">To Date</label>
            <input type="text" class="form-control" id="to_date" jDate [formCtrl]="invoiceFilter.controls['to_date']"/>
          </div>
        </div>

        <div class="row mb-1 mx-1">
          <div class="col-12 d-flex justify-content-end">
            <button type="button" class="btn limos-button-background btn-sm mr-2 text-white" (click)="searchInvoice()">Search</button>
            <button type="button" class="btn btn-secondary btn-sm" (click)="resetInvoiceFilter()">Cancel</button>
          </div>
        </div>
      </div>
      <div class="card-body" *blockUI="'invoice-list-ui'">
        <div _ngcontent-bmk-c200="" class="row">
          <div class="col-md-12">
            <div class="w-100">
              <div class="row">
                <div class="col-12 primary-tab">
                  <ul class="nav nav-tabs">
                    <li class="nav-item text-black-contrast">
                      <button
                        [ngClass]="{
                          'bg-white': activeTab === 'invoices',
                          'text-uppercase': true
                        }"
                        class="nav-link"
                        (click)="selectTab('invoices')"
                      >
                        INVOICE
                      </button>
                    </li>
                    <li class="nav-item text-black-contrast">
                      <button
                        [ngClass]="{
                          'bg-white': activeTab === 'cases',
                          'text-uppercase': true,
                          active: activeTab === 'cases'
                        }"
                        class="nav-link"
                        (click)="selectTab('cases')"
                      >
                        By Case
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="invoices-list bg-white" *ngIf="activeTab === 'invoices'">
          <app-invoice-list
            [invoiceLimit]="invoiceLimit"
            (invoiceSelected)="handleInvoiceSelected($event)"
            [invoiceFilter]="invoiceFilterApplied"
          >
          </app-invoice-list>
        </div>

        <div class="invoices-list bg-white" *ngIf="activeTab === 'cases'">
          <app-case-invoice-list></app-case-invoice-list>
        </div>
      </div>
    </div>
  </div>
</div>
